import React, { useState, useEffect } from "react";
import "./CollectionList.scss";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import Api from "../../Common/api.jsx";
import MetaMaskService from "../../Common/metamaskService.jsx";
import { Navigate } from "react-router-dom";
import SkeletonProduct  from "../../Pages/Skeleton/index.jsx";
import { Link } from "react-router-dom";

export default class CollectionList extends React.Component {
  constructor(props) {
    super(props);
    this.timeout = 0;
    this.state = {
      loader : false,
      collections: [],
      totalRecords: 0,
      pageNumber: 1,
      pageSize: 20,
      account: null,
      isGoToCreateCollection: false,
    };
  }
  async componentDidMount() {
    let account = await new MetaMaskService().getAccount();

    this.setState({ account: account }, () => {
      this.getCollections();
    });
  }

  getCollections() {
    const api = new Api();
    this.setState({loader: true});
    const obj = {
      pagenumber: this.state.pageNumber,
      pagesize: this.state.pageSize,
      account: this.state.account,
    };

    api
      .post("my_collections/", obj)
      .then((response) => {
        this.setState({
          collections: [
            ...this.state.collections,
            ...response.data.collections,
          ],
          totalRecords: response.data.totalRecords,
        });
        this.setState({loader: false});
      })
      .catch((err) => console.log(err));
  }

  loadMoreCollections(event) {
    event.preventDefault();

    var totalRecords = this.state.totalRecords;
    var totalPages = Math.ceil(totalRecords / this.state.pageSize);
    if (this.state.pageNumber > totalPages) return;

    this.setState({ pageNumber: this.state.pageNumber + 1 }, () => {
      this.getCollections();
    });
  }

  toggleMoreButton() {
    var totalRecords = this.state.totalRecords;
    var totalPages = Math.ceil(totalRecords / this.state.pageSize);
    return this.state.pageNumber < totalPages;
  }

  render = () => {
    if (this.state.isGoToCreateCollection) {
      return <Navigate to={"/CreateCollection"} />;
    }
    return (
      <>
        <Header />
        <div className="main-container">
          <div className="container">
            <div className="section-title">
              <h2>Discover more Collections</h2>
            </div>
            <div className="create-collection">
              <button
                className="button create-collection-btn"
                onClick={() => {
                  this.setState({ isGoToCreateCollection: true });
                }}
              >
                Create New Collection
              </button>
            </div>
            <div className="filter-list-box-wrap">
            {!this.state.loader ? (
              <ul className="explore-nfts">
                {this.state.collections.map((explores, index) => (
                  <li key={index}>
                    <Link
                      to={
                        "../CollectionDetails/?collectionId=" +
                        explores.collection_id
                      }
                      className="card"
                    >
                      <div className="card-img">
                        <img src={explores.collection_image  ? explores.collection_image
                      : "../images/card1.png"} alt="discover" />
                      </div>
                      <div className="card-body">
                        <div className="artist-block">
                          <div className="media">
                            <div className="media-img">
                              <img
                                src={explores.user_profile_image}
                                alt="artist block"
                              />
                            </div>
                            <div className="media-body">
                              <span>{explores.collection_name}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
              ) :  [1, 2, 3, 4,5,6,].map(loading =>(
                    <>
                      <div className="skeleton-items" key={loading}>
                      <SkeletonProduct />
                      </div>
                    </>
                  ))}
            </div>
            <div className="button-wrap">
              {this.toggleMoreButton() ? (
                <button
                  onClick={(event) => this.loadMoreCollections(event)}
                  className="button purple-outline"
                >
                  Show More
                </button>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  };
}
